var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnkr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#2E6BF6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73912 3.54375L13.4629 5.42812C14.0029 5.70937 14.3438 6.24375 14.3438 6.8625V7.73438H12.9791V6.8625C12.9791 6.77812 12.9229 6.69375 12.8374 6.6375L9.11362 4.75312C9.05737 4.725 8.97131 4.725 8.88638 4.75312L5.16263 6.6375C5.07769 6.66563 5.02087 6.75 5.02087 6.8625V7.73438H3.65625V6.8625C3.65625 6.27187 3.99712 5.70937 4.53712 5.42812L8.26087 3.54375C8.71594 3.31875 9.25594 3.31875 9.73912 3.54375ZM10.1655 8.94375C10.1655 8.29688 9.6255 7.79063 9 7.79063C8.34637 7.79063 7.8345 8.29688 7.8345 8.94375C7.8345 9.59062 8.3745 10.0969 9 10.0969C9.6255 10.0969 10.1655 9.59062 10.1655 8.94375ZM12.8092 11.3625C12.8936 11.3344 12.951 11.25 12.951 11.1375V10.2656H14.3151V11.1375C14.3151 11.7281 13.9742 12.2906 13.4342 12.5719L9.71044 14.4563C9.48319 14.5688 9.22725 14.625 8.97131 14.625C8.71594 14.625 8.45944 14.5688 8.23275 14.4563L4.53712 12.5719C3.99712 12.2906 3.65625 11.7562 3.65625 11.1375V10.2656H5.02087V11.1375C5.02087 11.2219 5.07713 11.3063 5.16263 11.3625L8.31825 12.9375V11.3625C7.23769 11.0531 6.47044 10.0969 6.47044 8.94375C6.47044 7.56562 7.60669 6.4125 9.02869 6.4125C10.4214 6.4125 11.5864 7.5375 11.5864 8.94375C11.5864 10.0969 10.791 11.0813 9.73912 11.3625V12.9375L12.8092 11.3625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnkr);
export default __webpack_public_path__ + "static/media/ankr.a0751c60fd11134312b56ef0cd097e16.svg";
export { ForwardRef as ReactComponent };